import SuggestedUser from "./SuggestedUser";

import { useQuery } from "@apollo/client";

import Spinner from "./Spinner";
import { useAuthContext } from "../hooks/useAuthContext";
import { GET_SUGGESTED_USERS } from "../queries/userQueries";
import { useState } from "react";

export default function RightPanel() {
  const { authUser } = useAuthContext()
  const [suggestedUsers, setSuggestedUsers] = useState([])

  const { loading } = useQuery(GET_SUGGESTED_USERS, {
    variables: { id: authUser?.id },
	onCompleted: (data) => {
	  setSuggestedUsers(data.suggestedUsers)
	}
  })

  if (suggestedUsers?.length === 0) return <div className='md:w-64 w-0'></div>

  return (
	<div className='bg-dark mx-auto p-4 rounded sticky-top'>
	  <p className='text-body rfs-3 text-center mt-2'>Who to follow</p>
	  <div className='d-flex flex-column'>
		{/* item */}
		{loading ? (
		  <Spinner marginSize='40px' />
		) : (
		  suggestedUsers?.map((user) => (
			<SuggestedUser key={user.id} authUser={authUser} user={user} />
		  ))
		)}
	  </div>
	</div>
  )
}
